module.exports = __webpack_public_path__ + "img/baggage2.04005c0a.png";